import { ButtonType, DialogFooterButtonsWidget, TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { CommonStyles } from '~common/react/CommonStyles';

import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';
import { L10n } from '~src/ts/L10n/L10n';
import { IPublishedConnectionTaskInfo } from '~src/ts/models/IPublishedConnectionTaskInfo';
import { PublishedConnectionTaskSchedulePicker } from './PublishedConnectionTaskSchedulePicker';

const cssPrefix = 'PublishedConnectionEditScheduleDialogContent';

const rootClass = cssClass(cssPrefix, 'root', {
  padding: `0 ${CommonStyles.Sizes.SmallSpace}px ${CommonStyles.Sizes.LargeSpace}px`
});

const dialogMessageClass = cssClass(cssPrefix, 'dialogMessage', {
  marginBottom: TabStyles.Spacing.LargeSpace,
  wordWrap: 'break-word'
});

export const PublishedConnectionEditScheduleDialogContent: React.FC<{
  tasks: ReadonlyArray<IPublishedConnectionTaskInfo>;
  dismiss: () => void;
}> = (
  {
    tasks,
    dismiss
  }) => {
  const [selectedSchedule, setSelectedSchedule] = React.useState('');
  const handleSelectSchedule = React.useCallback((value) => setSelectedSchedule(value), []);

  const handleEditSchedule = React.useCallback(
    () => {
      //TODO: trigger edit schedule action
    },
    []
  );

  return (
    <div>
      <div className={rootClass}>
        <div
          className={dialogMessageClass}>{Messages.changeScheduleExtractTasksPrompt({ COUNT_LOC: L10n.localizedCount(tasks.length) })}</div>
        <PublishedConnectionTaskSchedulePicker
          scheduleId={selectedSchedule}
          onSelect={handleSelectSchedule}
        />
      </div>

      <DialogFooterButtonsWidget
        buttons={[{
          handleClick: dismiss,
          buttonType: ButtonType.Outline,
          children: Messages.cancel(),
          testId: 'edit-published-connection-schedule-cancel'
        }, {
          handleClick: handleEditSchedule,
          buttonType: ButtonType.Primary,
          children: Messages.changeSubscriptionsFrequencyConfirm({
            COUNT: tasks.length,
            COUNT_LOC: L10n.localizedCount(tasks.length)
          }),
          testId: 'edit-published-connection-schedule-go',
          disabled: !selectedSchedule
        }]}
        testId={'edit-published-connection-schedule-footer'}
      />
    </div>
  );
};
PublishedConnectionEditScheduleDialogContent.displayName = 'PublishedConnectionEditScheduleDialogContent';
